let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3EOn7")).then(() => parcelRequire('53R9u'));